


























































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import faker from 'faker';
import AuthModule from '@/store/AuthModule';
import { payment, formatPaymentMethod } from '@/data/paymentMethods';
import NavBar from "@/layouts/prescriber/components/NavBar.vue";
import {
    getOffersPresciber,
    postPaymentPrescriber,
    getSubscriptionsPrescriber,
    getOffersPaymentUrlPresciber,
    getRequestMultiLicence,
    getCheckoutSession,
    getVerificationPayment,
    postSupportAddDaysMessage,
    postYoungAccess,
    postMultiAccess,
    postPlugFinanceSouscription,
    postPluginDemand
} from '@/api/api';
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import Offer from '@/models/Offer';
import get from 'lodash/get';
import SubscriptionPrescriber from '@/models/SubscriptionPrescriber';
import last from 'lodash/last';
import moment from 'moment';
import CGVPopup from '@/components/CGVPopup.vue';
import SmoothReflow from "@/components/SmoothReflow.vue";
import ButtonLoading from "@/components/ButtonLoading.vue";
import Subscription from "@/models/Subscription";
import { BACKEND_URL } from '@/helpers/constants';
import formatAmount from '@/utils/formatAmount';


@Component({
    filters: {
        capitalize: function (string: string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        euro: function (value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value);
        },
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        HT: function (value: number) {
            const price = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value / 1.2);
            return price.replace(/\s/g, "");
        },
        translatePaymentMethod: (value: string) => {
            return formatPaymentMethod(value);
        }
    },
    components: {
        CGVPopup,
        StripeCheckout
    }
})
export default class SubscriptionPrescriberComponent extends Vue {
    // @ts-ignore
    offerIds = {
        238.8: "price_1HaLelL9znGawtT3UBP9T9YX",
    }

    tabActive: string = 'plugimmo';
    subTabActive: any = {};
    popupYoung: Boolean = false;
    popupMulti: Boolean = false;
    siteTabActive: string = 'essentiel';
    siteAnnualy: boolean = false;
    siteAccordionOpen: number | null = null;
    siteDevisItems: any[] = [
        { title: 'Marketing', points: ['Creation de logo a partir de croquis', 'Creation de signature electronique personnalisee pour vos e-mails', 'Installation d\'un widget de chat pour capter des prospects directement sur votre site'] },
        { title: 'Site web personnalise', points: ['Insertion d\'images dans les pages souhaitees', 'Personnalisation des formulaires de contact'] },
        { title: 'Compte Google My Business', points: ['Creation et parametrage pour maximiser votre visibilite en ligne', 'Integration des avis Google sur la page d\'accueil de votre site', 'Affichage de vos avis Google My Business sur les pages de votre choix'] },
        { title: 'Google Ads', points: ['Creation du compte avec parametrage des mots-cles et des campagnes', 'Outil de captation de prospects vendeurs, couple a Google Ads'] },
        { title: 'Statistiques de trafic', points: ['Creation et integration de systemes de tracking sur toutes les pages de votre site'] },
        { title: 'Canva', points: ['Video de presentation de vos biens avec musique', 'Une page dediee a la presentation de votre book personnalise pour la prise de mandat en transaction', 'Une page dediee a la presentation de votre book personnalise pour la prise de mandat de location'] },
        { title: 'Paiements', points: ['Creation et parametrage complet de votre compte Stripe pour generer des liens de paiement et/ou des prelevements a destination de vos clients.'] },
    ];

    BACKEND_URL = BACKEND_URL;

    popupCGV: Boolean = false;
    termsAndConditions: Boolean = false;
    offers: Offer[] = [];
    sessionId: number = 0;
    returnType: 'succes' | 'echec' | null = null;

    offersForTab: any = [];
    annualy: Boolean = false;

    get userOffer() {
        return AuthModule.subscriptions;
    }

    async postPlugFinance() {
        const { data } = await postPlugFinanceSouscription()
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande d\'accès Plugfinance envoyée',
        });
    }


    async postPlugin() {
        const { data } = await postPluginDemand()
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande d\'accès au PlugIn envoyée',
        });
    }

    async postAddDays() {
        await postSupportAddDaysMessage();
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande de prorogation envoyée',
        });
    }

    async getYoungAccess() {
        await postYoungAccess()
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande d\'accès jeune cabinet envoyée',
        });
        this.popupYoung = false;
    }

    async getMultiAccess() {
        await postMultiAccess()
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande d\'accès Multi licences envoyée',
        });
        this.popupMulti = false;
    }

    get subscriptions() {
        return AuthModule.subscriptions;
    }



    get wasTrial() {
        let subscriptions = AuthModule.subscriptions;
        let isTrialActive = AuthModule.isTrialActive;
        let isSubActive = AuthModule.isSubscriptionActive;
        if (subscriptions.length == 0 && !isTrialActive && !isSubActive) {
            return true;
        }
        return false;
    }

    get isRestricted() {
        return AuthModule.isRestricted;
    }

    async requestMultiLicence() {
        let request = getRequestMultiLicence();
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: 'Demande envoyée',
        });
    }

    async showPopupYoung() {
        this.popupYoung = true;
    }

    async checkout(offer: Offer) {
        const checkout = await getCheckoutSession(offer);
        const checkoutId = checkout.data;
        const $vs = (this as any).$vs;

        if (checkoutId) {
            //@ts-ignore
            let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
            stripe.redirectToCheckout({ sessionId: checkoutId });
        } else {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: "Paiement impossible pour le moment, veuillez contacter l'administration PlugIMMO",
            });
        }
        /**
        const stripeScript = document.createElement('script')
        stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
        stripeScript.onload = () => {
            var productId: string = ''

            if (offer.id == 1) {
                var productId = "price_1HaLelL9znGawtT3UBP9T9YX"
            } else if (offer.id == 3) {
                var productId = "price_1ISgRFL9znGawtT3A6FVSgl3"
            }

            // @ts-ignore
            let stripe = Stripe('pk_test_51HZYDeL9znGawtT3qHF7q9RWn6PDJeYlkqIVwGzrlpOYfiTmU3w919S7BDAE2mFRQmvmzEzFpQcpOLj0FyhzqVGq00Hj94RnrV');
            if(offer.payment_method == "CB") {
                stripe.redirectToCheckout({
                    lineItems: [
                        // Replace with the ID of your price
                        { price: productId, quantity: 1 },
                    ],
                    mode: 'payment',
                    // Do not rely on the redirect to the successUrl for fulfilling
                    // purchases, customers may not always reach the success_url after
                    // a successful payment.
                    // Instead use one of the strategies described in
                    // https://stripe.com/docs/payments/checkout/fulfill-orders
                    successUrl: 'https://localhost:8080/abonnement/succes?',
                    cancelUrl: 'https://localhost:8080/abonnement/echec',
                })
            } else  {
                stripe.redirectToCheckout({
                    lineItems: [
                        // Replace with the ID of your price
                        { price: productId, quantity: 1 },
                    ],
                    mode: 'subscription',
                    // Do not rely on the redirect to the successUrl for fulfilling
                    // purchases, customers may not always reach the success_url after
                    // a successful payment.
                    // Instead use one of the strategies described in
                    // https://stripe.com/docs/payments/checkout/fulfill-orders
                    successUrl: 'https://app.plugimmo.pro/abonnement/succes',
                    cancelUrl: 'https://app.plugimmo.pro/abonnement/echec',
                })
            }
        }
        document.head.appendChild(stripeScript)
        //var checkoutButton = document.getElementById("checkout-button");
        //const resp = await getOffersPaymentUrlPresciber(offer.id);
        */
    }

    async created() {
        const resp = await getOffersPresciber();
        this.offers = resp.data;

        this.offersForTab = this.createOffersTabs()
        this.subTabActive = this.offersForTab['expert']
        if (
            this.$route.params.slug === 'succes' ||
            this.$route.params.slug === 'echec'
        ) {
            this.$route.params.slug;
            this.returnType = this.$route.params.slug;
            if (this.returnType == 'succes') {
                const verif = await getVerificationPayment();
                if (verif.data === 'created') {
                    document.location.reload();
                }
            }
            this.$router.replace({
                name: 'subscription',
                params: {
                    slug: '',
                },
            });
        }
    }

    createOffersTabs() {
        const state: any = {
            starter: {
                monthly: null,
                annualy: null
            },
            expert: {
                monthly: null,
                annualy: null
            }
        };
        for (const offer in this.offers) {
            const actual: any = this.offers[offer];
            //@ts-ignore
            if (state[actual.type] && state[actual.type][actual.duration] == null) {
                state[actual.type][actual.duration] = actual;
            }
        }

        return state;
    }

    get subscriptionEnd() {
        var max = null;

        for (var i in this.subscriptions) {
            var subscription = this.subscriptions[i];

            if (!max || (subscription.end_at && Date.parse(subscription.end_at) > Date.parse(max))) {
                max = subscription.end_at;
            }
        }

        return max;

        // const lastSubscription = last(this.subscriptions);
        // if (lastSubscription) {
        //     return lastSubscription.end_at;
        // }
        // return null;
    }

    get offersWidthDiscount() {
        return this.offers.map((sub, index) => {
            // On calcul le discount en fonction du premier offer
            const discount = (() => {
                if (index === 0) {
                    return 0;
                }

                //const perDay = sub.price / sub.days_duration;

                const firstSub = this.offers[0];
                //const firstPerDay = firstSub.price / firstSub.days_duration;
                const firstSubSameDay = firstSub.price * Math.round((sub.days_duration / 30));
                if (sub.price < firstSubSameDay) {
                    //return firstPerDay * sub.days_duration - sub.price;

                    var value = (firstSubSameDay - sub.price) / firstSubSameDay
                    return new Intl.NumberFormat('fr-FR', {
                        style: 'percent',
                        minimumFractionDigits: 0,
                    }).format(value);
                }
                return 0;
            })();


            return {
                ...sub,
                discount,
            };
        });
    }

    async buy(offer: Offer) {
        const $vs = (this as any).$vs;

        try {
            const { data } = await getOffersPaymentUrlPresciber(offer.id);
            const url = data.url;

            window.location.href = url;
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Veuillez renseigner votre adresse',
            });

            this.$router.push({ name: 'profilePrescriber' });
        }
    }

    get isTrialActive() {
        return AuthModule.isTrialActive;
    }

    get isSubscriptionActive() {
        return AuthModule.isSubscriptionActive;
    }

    get trialEnd() {
        if (!AuthModule.enabledAt) {
            return null;
        }
        return moment(AuthModule.enabledAt).add(14, 'days');
    }
}
